import { OptionsEnum } from '../../enums/OptionsEnum';

type EmptyString = '';

export class PersonalDetails {
  sumAssuredAOV = 0;
  averageYearIncome: number | string = '';
  insuranceSomewhereElse: OptionsEnum | EmptyString = '';
  deductPremiumFromTaxes: OptionsEnum | EmptyString = '';
  companyName = '';
  insurerWillCancelInsurance: OptionsEnum = OptionsEnum.Yes;
  cancellationDate = new Date();
  monthlyExpenses: number | string = '';
}
